import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { setPaginationParams } from "../../../helpers";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.feeShares = this.feeShares.bind(this);
    this.feeShare = this.feeShare.bind(this);
    this.params = this.params.bind(this);
    this.deployerFeeShares = this.deployerFeeShares.bind(this);
    this.withdrawerFeeShares = this.withdrawerFeeShares.bind(this);
  }
  /* FeeShares retrieves all registered FeeShares */

  async feeShares(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `juno/feeshare/v1/fee_shares`;
    return await this.req.get(endpoint, options);
  }
  /* FeeShare retrieves a registered FeeShare for a given contract address */

  async feeShare(params) {
    const endpoint = `juno/feeshare/v1/fee_shares/${params.contractAddress}`;
    return await this.req.get(endpoint);
  }
  /* Params retrieves the FeeShare module params */

  async params(_params = {}) {
    const endpoint = `juno/feeshare/v1/params`;
    return await this.req.get(endpoint);
  }
  /* DeployerFeeShares retrieves all FeeShares that a given deployer has
   registered */

  async deployerFeeShares(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `juno/feeshare/v1/fee_shares/${params.deployerAddress}`;
    return await this.req.get(endpoint, options);
  }
  /* WithdrawerFeeShares retrieves all FeeShares with a given withdrawer
   address */

  async withdrawerFeeShares(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }
    const endpoint = `juno/feeshare/v1/fee_shares/${params.withdrawerAddress}`;
    return await this.req.get(endpoint, options);
  }
}